import React from "react";
import MaintainancePic from "../images/hanna-temp.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaintRoller } from "@fortawesome/free-solid-svg-icons";
import { Footer } from "../components/Footer";

interface Props {
  Title: string;
}

const Maintenance = (props: Props): any => {
  return (
    <>
      <div className="wrapper">
        <div className="section">
          <div className="container">
            <div className="row">
              <div className="col-md-6 ml-auto mr-auto text-center">
                <h2 className="title text-center">{props.Title}</h2>
                <p>
                  <FontAwesomeIcon
                    className="center"
                    icon={faPaintRoller}
                    size="6x"
                  />
                </p>
                <hr />
                <p>
                  This site is currently undergoing maintenance. Sorry for any
                  inconvenience.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
